import {createAsyncThunk} from '@reduxjs/toolkit';
import {CLDispatch, RootState} from 'common/src/redux/store';
import {setBrandVideos} from '../brandAssets.slice';
import brandAssetsApi from 'common/src/modules/Assets/brandAssets/brandAssets.api';
import {AssetType} from 'common/src/modules/Assets/Assets.enums';

export const loadBrandVideos = createAsyncThunk<
  void,
  void,
  {dispatch: CLDispatch; state: RootState}
>('brandAssets/loadBrandVideos', async (_, {dispatch, rejectWithValue}) => {
  try {
    const assets = await brandAssetsApi.getBrandAssets(AssetType.Video);
    dispatch(setBrandVideos(assets));
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch brand video assets';

    return rejectWithValue(errorMessage);
  }
});
